import _slicedToArray from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import React, { useState } from 'react';
import { Button, Dialog, DialogContent, DialogTitle, DialogActions, TextField } from '@mui/material';
export var HTTPBasicLoginForm = function HTTPBasicLoginForm(_ref) {
  var internetAccountId = _ref.internetAccountId,
    handleClose = _ref.handleClose;
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    username = _useState2[0],
    setUsername = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    password = _useState4[0],
    setPassword = _useState4[1];
  function onSubmit(event) {
    if (username && password) {
      handleClose(btoa("".concat(username, ":").concat(password)));
    } else {
      handleClose();
    }
    event.preventDefault();
  }
  return React.createElement(React.Fragment, null, React.createElement(Dialog, {
    open: true,
    maxWidth: "xl",
    "data-testid": "login-httpbasic"
  }, React.createElement(DialogTitle, null, "Log In for ", internetAccountId), React.createElement("form", {
    onSubmit: onSubmit
  }, React.createElement(DialogContent, {
    style: {
      display: 'flex',
      flexDirection: 'column'
    }
  }, React.createElement(TextField, {
    required: true,
    label: "Username",
    variant: "outlined",
    inputProps: {
      'data-testid': 'login-httpbasic-username'
    },
    onChange: function onChange(event) {
      return setUsername(event.target.value);
    },
    margin: "dense"
  }), React.createElement(TextField, {
    required: true,
    label: "Password",
    type: "password",
    autoComplete: "current-password",
    variant: "outlined",
    inputProps: {
      'data-testid': 'login-httpbasic-password'
    },
    onChange: function onChange(event) {
      return setPassword(event.target.value);
    },
    margin: "dense"
  })), React.createElement(DialogActions, null, React.createElement(Button, {
    variant: "contained",
    color: "primary",
    type: "submit"
  }, "Submit"), React.createElement(Button, {
    variant: "contained",
    type: "submit",
    onClick: function onClick() {
      return handleClose();
    }
  }, "Cancel")))));
};